import capitalize from 'lodash/capitalize';
import { CurrencyIsoCode, TransactionStatus } from 'shared/data/wallets/v1';

export const statuses = Object.values(TransactionStatus).map((status) => ({
    id: status,
    name: capitalize(status),
}));

export const currenciesPriority = [CurrencyIsoCode.GBP, CurrencyIsoCode.USD, CurrencyIsoCode.EUR, CurrencyIsoCode.AUD];
